// Profil-Nachbau F-23 (PF-NB-hilfe-1; Nutzerblick Mitglied Z-01, 15.10.2026): die Recherchetipps an einer Stelle. Die Startseite
// (pages/Dashboard.tsx, das Fenster „Wie stelle ich eine gute Rechtsfrage?“ (seit F-24)) und die Anleitung „Wie stelle ich eine gute
// Rechtsfrage?“ in „Hilfe und Feedback“ (pages/einstellungen/hilfeThemen.ts) nehmen die Sätze von hier; die Hilfe belegt sie mit
// dieser Datei.
import type { ErklaerInhalt } from '../components/Erklaerung';

export const RECHERCHE_TIPPS = [
  { titel: 'Kontext mitgeben', satz: 'Nennen Sie Sachverhalt, Zeitraum und die konkrete Rechtsfrage.' },
  { titel: 'Quellen nachlesen', satz: 'Öffnen Sie verlinkte Fundstellen und prüfen Sie Fassung, Datum und Zusammenhang.' },
  { titel: 'Im Dialog vertiefen', satz: 'Fragen Sie nach Voraussetzungen, Ausnahmen oder abweichender Judikatur.' },
] as const;

export const RECHERCHE_TIPPS_TEXTE = {
  // F-24 (PF-TX-rahmen-3): die Tipps stehen im Fenster „Wie stelle ich eine gute Rechtsfrage?“ statt in einer Spalte; die
  // Frage ist der Titel des Hilfe-Themas (hilfeThemen.ts GUTE_FRAGE_ID), der Fußsatz stand bis F-24 unter dem Eingabefeld.
  frage: 'Wie stelle ich eine gute Rechtsfrage?',
  fuss: 'Die Recherche startet direkt im Chat.',
} as const;

/** Anker der Anleitung in „Hilfe und Feedback“ › „Dokumente“ (hilfe-<id>, wie pages/einstellungen/Hilfe.tsx hilfeAnker). */
export const GUTE_FRAGE_ID = 'gute-frage';

/** F-24 (PF-TX-rahmen-3, SPEC-rahmen 3.1 F1): das Fenster der Startseite, nummeriert in der Reihenfolge der Tipps. */
export const GUTE_FRAGE_FENSTER: ErklaerInhalt = {
  frage: RECHERCHE_TIPPS_TEXTE.frage,
  teile: RECHERCHE_TIPPS.map((tipp, index) => ({ titel: `${index + 1}. ${tipp.titel}`, text: tipp.satz })),
  fuss: RECHERCHE_TIPPS_TEXTE.fuss,
  hilfe: GUTE_FRAGE_ID,
};
